// extracted by mini-css-extract-plugin
export default {"container":"jNkXs2qZzB7xbgchGg4J","header":"UXemy6dbJdNqFuZDtOO8","logo":"_FfNJ8pfNCCDyT95SGye","text":"UlWYMEWoMkG5ZU4cl_x8"};